import React from "react";
import RadioCheckbox from "components/Form/Controls/RadioCheckbox";

const Checkbox = ({ ...props }) => {
    return <RadioCheckbox type="checkbox" {...props} />;
};

Checkbox.propTypes = {
    ...RadioCheckbox.propTypes
};

export default Checkbox;
